import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const Alert = ({ children, mods={}, severity='success', startIcon, endIcon }) => {
    const { className } = useMods(Alert, { mods: { ...mods, severity } }, true);

    return (
        <div
            className={ className }
            role='alert'
        >
            { startIcon }
            { children }
            { endIcon }
        </div>
    );
};

Alert.displayName = 'Alert';

Alert.propTypes = {
    children: PropTypes.node,
    endIcon: PropTypes.node,
    mods: PropTypes.object,
    severity: PropTypes.string,
    startIcon: PropTypes.node
};

export default Alert;
